export const oops = {
  title: 'Проблема не в тобі, а в нас',
  description1: "Будь ласка, перевір з'єднання та спробуй ще раз.",
  description2: 'Не допомагає?',
  link: 'Сконтактуй адміна',
};
